import { useMutation } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import { verifyOtp } from '../api';
import { otpMutationKeys } from '../data';

export const useVerifyOtpMutation = () => {
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationKey: otpMutationKeys.verifyOtp,

    mutationFn: verifyOtp,

    onSuccess: (response) => {
      const { accessToken, refreshToken } = response.data.tokenResponse;

      Cookies.set('access_token', accessToken, {
        domain: ENV.WHAT_ABILITY_DOMAIN,
        expires: 1,
      });

      Cookies.set('refresh_token', refreshToken, {
        domain: ENV.WHAT_ABILITY_DOMAIN,
        expires: 30,
      });

      Cookies.remove('pre_auth_token', {
        domain: ENV.WHAT_ABILITY_DOMAIN,
        path: '/',
      });

      toast.success('Authenticated');
      navigate('/dashboard');
    },

    onError: () => {
      toast.error('Invalid OTP');
    },
  });

  return mutation;
};
